declare const THREE: any;

export class Button extends (THREE.Mesh as { new(geometry, material): any; }) {

  private cameraWorldPosition = new THREE.Vector3();

  constructor(texture, name: string, layer: number) {

    super(
      new THREE.PlaneBufferGeometry(25, 25),
      new THREE.MeshBasicMaterial({
        map: texture,
        depthTest: false,
        transparent: true
      })
    );

    this.name = name;

    this.layers.set(layer);
  }

  onBeforeRender(renderer, scene, camera) {
    if (camera instanceof THREE.PerspectiveCamera) {
      camera.getWorldPosition(this.cameraWorldPosition);
      const vector = this.parent.worldToLocal(this.cameraWorldPosition);
      this.lookAt(vector);
    } else {
      this.rotation.set(-1.5, 0, 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/custom/Controls/Button.ts